<template>
  <div class="user-progress-component px-2 mt-3" v-if="course_info">
    <div class="page-title sm mb-1">
      Meu progresso
    </div>
    <div class="d-flex align-items-center">
      <div class="progress-bar w-100 mr-2" :style="progress" />
      <span>{{ course_info.course_progress }}</span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("user", ["course_info"]),
    progress() {
      if (this.course_info)
        return { "--progress": `${this.course_info.course_progress}` };

      return 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.user-progress-component {
}
</style>
